// extracted by mini-css-extract-plugin
export var cenik = "ultherapyMain-module--cenik--37Xet";
export var headline = "ultherapyMain-module--headline--1RCqJ";
export var container1 = "ultherapyMain-module--container1--X2uK9";
export var container2 = "ultherapyMain-module--container2--3mJzP";
export var container3 = "ultherapyMain-module--container3--bJJD4";
export var heroIntro = "ultherapyMain-module--heroIntro--2eN9N";
export var title = "ultherapyMain-module--title--3dCjo";
export var titleSmall = "ultherapyMain-module--titleSmall--25vtM";
export var titleDN = "ultherapyMain-module--titleDN--2np3V";
export var titleDNT = "ultherapyMain-module--titleDNT---9i0m";
export var sectionTitle = "ultherapyMain-module--sectionTitle--2zDrF";
export var benefitsList = "ultherapyMain-module--benefitsList--3Fw-K";
export var benefitItem = "ultherapyMain-module--benefitItem--48DyC";
export var benefitTitle = "ultherapyMain-module--benefitTitle--tc6f-";
export var benefitText = "ultherapyMain-module--benefitText--3xSDM";
export var areasGrid = "ultherapyMain-module--areasGrid--Jr-Hy";
export var areaCard = "ultherapyMain-module--areaCard--3VACx";
export var areaLabel = "ultherapyMain-module--areaLabel--38Ze6";
export var areaText = "ultherapyMain-module--areaText--2LKAr";
export var factBlock = "ultherapyMain-module--factBlock--13L8p";
export var factText = "ultherapyMain-module--factText--OyqK7";
export var historyBlock = "ultherapyMain-module--historyBlock--2oGD1";
export var milestone = "ultherapyMain-module--milestone--1hPTb";
export var milestoneYear = "ultherapyMain-module--milestoneYear--f-L95";
export var milestoneText = "ultherapyMain-module--milestoneText--2yBNo";
export var placeholderImage = "ultherapyMain-module--placeholderImage--3btU0";
export var placeholderImageWide = "ultherapyMain-module--placeholderImageWide--jJwyO";
export var imageWrapper = "ultherapyMain-module--imageWrapper--1qVMT";
export var imageWrapperWide = "ultherapyMain-module--imageWrapperWide--2kEHb";
export var brush1 = "ultherapyMain-module--brush1--3VGHp";
export var brush2 = "ultherapyMain-module--brush2--2xAJs";
export var subtitle = "ultherapyMain-module--subtitle--2xmtc";
export var divider = "ultherapyMain-module--divider--2P6Ng";
export var bodyText = "ultherapyMain-module--bodyText--3dVZV";
export var quoteImageWrapper = "ultherapyMain-module--quoteImageWrapper--1Q2JD";
export var quoteDecor1 = "ultherapyMain-module--quoteDecor1--2wYej";
export var quoteDecor2 = "ultherapyMain-module--quoteDecor2--1Zppq";
export var mAuto = "ultherapyMain-module--mAuto--2vHCE";
export var mWidth640 = "ultherapyMain-module--mWidth640--2vAy7";